import { type CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { BreakpointNames } = constants.breakpoints;
const { ui } = constants.colors;

const coreBlue25 = ui.core[25];
const neutral700 = ui.neutral[700];
const darkBlue = ui.core[700];
const white = ui.white[700];
interface overviewFontBuilderCssProps {
  fontWeight?: string;
  textOverflow?: string;
  fontSize?: string;
  fontStyle?: string;
  lineHeight?: string;
}
export const dataInfoCardHorizontalCss: CSSObject = {
  minHeight: "7rem",
  textAlign: "left",
  display: "flex",
  flexDirection: "row",
};
export const overviewFontBuilderCss = ({
  fontWeight,
  textOverflow,
  fontSize,
  fontStyle,
  lineHeight,
}: overviewFontBuilderCssProps) => ({
  fontFamily: "Circular",
  fontWeight,
  textOverflow,
  fontSize,
  fontStyle,
  lineHeight,
});
export const dataInfoCardCss = (isClassroomOverviewCard = true): CSSObject => ({
  minHeight: isClassroomOverviewCard ? "13.5rem" : "10rem",
  height: "100%",
  textAlign: "left",
  [breakpoint.upTo(BreakpointNames.xs)]: {
    minHeight: "8rem",
  },
});
export const averageReadingLevelContentMainContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "start",
  gap: "6px",
};
export const averageReadingLevelContentRowCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  height: "66px",
  padding: "8px",
  backgroundColor: white,
  borderRadius: "8px",
  textAlign: "center",
};
export const averageReadingLevelContentRowValueCss: CSSObject = {
  color: darkBlue,
  width: "20%",
  textAlign: "end",
  display: "block",
  ...overviewFontBuilderCss({
    fontSize: "1.5rem",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "133%",
  }),

  [breakpoint.upTo("sm")]: {
    width: "25%",
  },
};
export const averageReadingLevelContentRowValueDescriptionCss: CSSObject = {
  textAlign: "start",

  [breakpoint.downTo("sm")]: {
    fontSize: "1rem",
  },
  width: "70%",
};
export const containerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  width: "100%",
  height: "100%",
  gap: "10px",
};
export const chartsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  height: "100%",
};
export const containerDescriptionCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
  alignItems: "center",
  gap: "8px",
  width: "100%",

  p: {
    margin: 0,
    color: neutral700,
    ...overviewFontBuilderCss({
      fontSize: "0.93rem",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "171%",
    }),
  },
};
export const overviewDataResultsCss: CSSObject = {
  display: "grid",
  gap: "8px",
  gridTemplateColumns: "2fr 0.5fr 0.5fr 1fr",
  gridTemplateRows: "none",
  marginTop: "32px",

  [breakpoint.upTo("1300px")]: {
    gridTemplateRows: "auto auto",
    gridTemplateColumns: "1fr 1fr 2fr",
    "& > :nth-of-type(1)": {
      gridColumn: "1 / -1",
    },
    "& > :nth-of-type(2)": {
      gridColumn: "1",
    },
    "& > :nth-of-type(3)": {
      gridColumn: "2",
    },
    "& > :nth-of-type(4)": {
      gridColumn: "3",
    },
  },
  [breakpoint.upTo("767px")]: {
    gridTemplateRows: "auto auto auto",
    gridTemplateColumns: "1fr 1fr",
    "& > :nth-of-type(1)": {
      gridColumn: "1 / -1",
    },
    "& > :nth-of-type(2)": {
      gridColumn: "1",
    },
    "& > :nth-of-type(3)": {
      gridColumn: "2",
    },
    "& > :nth-of-type(4)": {
      gridColumn: "1 / -1",
    },
  },
};
export const overviewDataResultsWithNweaCss: CSSObject = {
  display: "grid",
  gap: "8px",
  gridTemplateColumns: "2fr repeat(3, 0.5fr) 1fr",
  gridTemplateRows: "none",
  marginTop: "32px",
  [breakpoint.upTo("1300px")]: {
    gridTemplateRows: "auto auto",
    gridTemplateColumns: "repeat(3, 1fr) 0.3fr",
    "& > :nth-of-type(1)": {
      gridColumn: "1 / 4",
    },
    "& > :nth-of-type(2)": {
      gridColumn: "4",
    },
    "& > :nth-of-type(3)": {
      gridColumn: "1",
    },
    "& > :nth-of-type(4)": {
      gridColumn: "2",
    },
    "& > :nth-of-type(5)": {
      gridColumn: "3 / -1",
    },
  },
  [breakpoint.upTo("767px")]: {
    gridTemplateRows: "auto auto auto",
    gridTemplateColumns: "2.05fr 1.2fr 0.8fr",

    "& > :nth-of-type(1)": {
      gridColumn: "1 / 3",
    },
    "& > :nth-of-type(2)": {
      gridColumn: "3",
    },
    "& > :nth-of-type(3)": {
      gridColumn: "1",
    },
    "& > :nth-of-type(4)": {
      gridColumn: "2 / -1",
    },
    "& > :nth-of-type(5)": {
      gridColumn: "1 / -1",
    },
  },
  [breakpoint.upTo("567px")]: {
    gridTemplateRows: "auto auto auto",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",

    "& > :nth-of-type(1)": {
      gridColumn: "1 / -1",
    },
    "& > :nth-of-type(2)": {
      gridColumn: "1",
    },
    "& > :nth-of-type(3)": {
      gridColumn: "2",
    },
    "& > :nth-of-type(4)": {
      gridColumn: "3",
    },
    "& > :nth-of-type(5)": {
      gridColumn: "1 / -1",
    },
  },
};
export const boxModelCss = {
  borderRadius: "16px",
  backgroundColor: coreBlue25,
};

export const descriptionCss = {
  color: neutral700,
  ...overviewFontBuilderCss({
    fontSize: "0.875rem",
    lineHeight: "150%",
    fontWeight: "400",
    textOverflow: "ellipsis",
    fontStyle: "normal",
  }),

  [breakpoint.downTo("md")]: {
    fontSize: "1rem",
  },
};
